<style>
button {
  background: transparent;
  border: none;
  cursor: pointer;
}

.pctofbalance {
  text-align: left;
  cursor: pointer;
}

.pctofbalance:hover {
  text-decoration: underline;
}

.blur-balance div {
  display: none;
}

.blur-balance:after {
  content: '*****';
}

.blur-balance-span span {
  display: none;
}

.blur-balance-span:after {
  content: '*****';
}

#executed > div > input[type='text'][disabled] {
  color: #5faaf5 !important;
}

.exchbtn {
  border-right: 1px solid var(--color-background);
  text-align: center;
  width: 140px;
  height: 100%;
  padding-top: 2px;
  font-weight: bold;
  font-size: 14pt;
  display: inline-block;
  cursor: pointer;
  position: relative;
}

#app {
  font-family: 'Exo 2', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: var(--color-text);
  height: 100%;
  /*overflow-x: hidden;*/
  /*overflow-y: hidden;*/
}

body {
  background-color: var(--color-background) !important;
  /*overflow-x:hidden;*/
  /*overflow-y: scroll;*/
}

body,
html {
  height: 100%;
  margin: 0;
}

html {
  -webkit-text-size-adjust: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.boxtitle {
  color: white;
  font-size: 10pt;
}

.box {
  background: var(--color-card);
  border-radius: 5px;
  font-size: 14px;
  /*box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19);*/
}

.newbox {
  background: var(--color-card-light);
  border-radius: 3px;
  font-size: 14px;
  padding: 20px;
  min-height: 510px;
  height: 100%;
}

.btnbox {
  background: var(--color-card);
  border-radius: 10px;
}

.headbox {
  margin-top: 0px;
  padding: 0px;
  width: 100%;
  text-align: left;
  overflow-x: hidden;
  overflow-y: hidden;
}

.symbbox {
  width: 100%;
  height: 400px;
  padding: 20px;
}

.clickable {
  cursor: pointer;
}

.active {
  background-image: linear-gradient(
    to bottom left,
    var(--color-accent-dark),
    var(--color-accent)
  );
}

::-webkit-scrollbar-track {
  /* -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3); */
  background-color: var(--color-scrollbar-track);
}

::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  background-color: var(--color-scrollbar-thumb);
}

.ivu-select-item-selected {
  background: var(--color-accent);
}

.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
}

.gred {
  color: var(--color-danger-light) !important;
}

.ggreen {
  color: var(--color-success-light) !important;
}

.gwhite {
  color: var(--color-text-light) !important;
}

.yell {
  color: var(--color-warning) !important;
}

.noselect {
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
}
</style>

<template>
  <div id="app">
    <!--<transition name="fade">-->
    <router-view />
    <!--</transition>-->
    <!--<MainPage/>-->
  </div>
</template>

<script>
import Api from './util/api'

const consoleLogs = []
const timerId = null

export default {
  name: 'App',
  data () {
    return {}
  },
  watch: {
    $route: function (route) {
      if (route.meta.watchLastPrice) {
        this.$store.state.sys.unwatchLastPrice()
        if (this.lastPrice) {
          document.title = `${this.lastPrice} ｜ ${this.symbol} ｜ Capico`
        }

        this.setTitleLastPriceWatcher()
      } else {
        this.destroyTitleLastPriceWatcher()
      }
    }
  },
  beforeDestroy () {
    clearInterval(timerId)
    this.destroyTitleLastPriceWatcher()
    window.removeEventListener('resize', this.onResize, { passive: true })
    if (window.visualViewport) {
      window.visualViewport.removeEventListener('resize', this.onResize)
    }
  },
  created () {
    this.setCurrentTheme()
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
    // Chrome iOS doesn't fire window.resize on rotation, only visualViewport.resize.
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', this.onResize, { passive: true })
    }

    this.consoleLogScammersWarning()

    // temporary disabled due to high traffic
    // this.setConsoleListener()
    // timerId = setInterval(this.sendErrors, 60 * 1000)

    Api.interceptors.response.use(
      response => {
        return response
      },
      error => {
        if (error.response && error.response.status === 401) {
          this.$store.state.sys.tradeExchange = {}
          this.$store.state.sys.token = ''
          localStorage.removeItem('token')
          window.location.href = '/app/login'
          // this.$router.push('/login')
        }
        return error
      }
    )
    if (this.$route.meta.watchLastPrice) {
      this.setTitleLastPriceWatcher()
    }
  },
  computed: {
    lastPrice () {
      return this.lastPriceName
        .split('.')
        .reduce((acc, val) => acc && acc[val], this)
    },
    lastPriceName () {
      switch (this.$route.name) {
        case 'terminal':
          return '$store.state.sys.lastPrice'
        case 'bots':
          return '$store.state.bots.lastPrice'
        case 'grids':
          return '$store.state.grids.lastPrice'
        default:
          return ''
      }
    },
    symbol () {
      let symbol = ''

      switch (this.$route.name) {
        case 'terminal':
          symbol = this.$store.state.trade.symbol
          break
        case 'bots':
          symbol = this.$store.state.bots.symbol
          break
        case 'grids':
          symbol = this.$store.state.grids.symbol
          break
      }

      return symbol.replace('_', '/')
    }
  },
  methods: {
    setCurrentTheme () {
      document.documentElement.classList = ''
      document.documentElement.classList.add(this.$store.state.sys.theme)
    },
    onResize () {
      if (window.innerWidth >= 1400) {
        this.$store.state.sys.breakpoint = 'xl'
      } else if (window.innerWidth < 1024) {
        this.$store.state.sys.breakpoint = 'small'
      } else {
        this.$store.state.sys.breakpoint = 'lg'
      }
    },
    setTitleLastPriceWatcher () {
      this.$store.state.sys.unwatchLastPrice = this.$watch(
        this.lastPriceName,
        function (value) {
          document.title = `${value} ｜ ${this.symbol} ｜ Capico`
        }
      )
    },
    destroyTitleLastPriceWatcher () {
      this.$store.state.sys.unwatchLastPrice()
      document.title = 'capico.app'
    },
    setConsoleListener () {
      const logTypes = ['log', 'error']

      logTypes.forEach(logType => {
        console[logType] = hookLogType(logType)
      })

      function hookLogType (logType) {
        const original = console[logType].bind(console)

        return function () {
          original.apply(console, arguments)

          if (arguments.length !== 1 || ![...arguments][0]) {
            return
          }
          const newLog = [...arguments][0].stack || [...arguments][0]
          // let newLog = {
          // Error: [...arguments][0].stack || [...arguments][0],
          // URL: location.href,
          // Ts: new Date().toISOString()
          // }

          consoleLogs.push(newLog)
        }
      }
    },
    async sendErrors () {
      if (!consoleLogs.length) {
        return
      }
      await Api.post(
        `weberr?token=${this.$store.state.sys.token}`,
        consoleLogs
      ).finally(() => {
        consoleLogs.length = 0
      })
    },
    consoleLogScammersWarning () {
      const logoImage =
        'data:image/png;base64,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'

      const styles = {
        header: 'color: lightcoral; font-size: 18px;',
        main: 'color: #6b74e7; font-size: 14px;',
        contact: 'color: lightseagreen; font-weight: bold; font-size: 14px;',
        logo: `font-size: 0px; background-image: url( ${logoImage} ); background-repeat: no-repeat; background-size: 100% 100%; background-size: no-cover ; padding: 12px;`
      }

      const logo = '  '
      const header = this.$text.tr(
        'Уважаемые трейдеры!\n\nОстерегайтесь мошенников.'
      )
      const main = this.$text.tr(
        'Не вставляйте данные в консоль и никому не показывайте данные из нее.\n\nПоступая так, вы рискуете безопасностью вашей учетной записи.\n\nОтправлять информацию разрешается только администраторам службы поддержки в Telegram'
      )
      const alex = '@alex_capico(https://t.me/alex_capico)'
      const and = this.$text.tr('и')
      const dmitry = '@dmitry_capico(https://t.me/dmitry_capico)'
      const orEmail = this.$text.tr(', или на почту')
      const support = 'support@capico.app.'

      const str = `%c${logo} %c\n\n${header} %c\n\n${main} - %c${alex} %c${and} %c${dmitry}%c${orEmail} %c${support}\n\n`

      console.log(
        str,
        styles.logo,
        styles.header,
        styles.main,
        styles.contact,
        styles.main,
        styles.contact,
        styles.main,
        styles.contact
      )
    }
  }
}
</script>
